export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/;
export const PHONE_NUMBER_REGEX = /^[\d]{7}$/;
